'use client'

import Toast from "@/components/Toast"
import Image from "next/image"
import CenterLayout from "@/layout/CenterLayout"
import { images } from "@/utils/images"
import { Button, Input, PasswordInput } from "@mantine/core"
import themeVariables from "@/config/theme/themeVariable"
import { useRef, useState } from "react"
import { API_ENDPOINT } from "@/config/endpoint/endpoint"
import { LogInIcon } from "lucide-react"
// import { handleSignIn } from "@/utils/auth" // 카카오 로그인 - 당분간 사용 중지

export default function LoginPage() {
  const idRef = useRef<HTMLInputElement>(null)
  const passwordRef = useRef<HTMLInputElement>(null)
  const [showIdLogin, setShowIdLogin] = useState(true)

  const handleLogin = async () => {
    if (!idRef.current?.value || !passwordRef.current?.value) {
      Toast.error('아이디와 비밀번호를 입력해주세요')
      return
    }
    await API_ENDPOINT.account.idLogin(idRef.current?.value, passwordRef.current?.value)
    .then(data => {
      if (data.result) {
        location.href = '/'
      }
    })
    .catch(err => {
      Toast.error('아이디와 비밀번호를 확인해주세요')
    })
  }


  const LoginTypeSelectButton = () => {
    return (
      <div className="flex flex-col gap-1.5 mt-10">
        {/* 카카오 로그인 - 당분간 사용 중지
        <div
          className="flex gap-1 rounded-lg bg-[#fee500] text-gray-800 !w-[300px] h-10 items-center justify-center cursor-pointer sm:w-[360px] hover:bg-[#f6dd00] active:scale-[98%] duration-200"
          onClick={handleSignIn}
        >
          <svg viewBox="0 0 21 20" width="21" height="21" fill="none">
            <path fillRule="evenodd" clipRule="evenodd" d="M10.5 2.62891C6.16282 2.62891 2.64282 5.36319 2.64282 8.72605C2.64282 10.8239 4.00211 12.6546 6.07639 13.7703L5.20425 16.9682C5.1878 17.0318 5.19118 17.0989 5.21396 17.1605C5.23673 17.2222 5.27781 17.2754 5.33167 17.313C5.38554 17.3506 5.44962 17.3709 5.51532 17.371C5.58102 17.3712 5.6452 17.3513 5.69925 17.3139L9.51782 14.776C9.83997 14.776 10.17 14.8311 10.5 14.8311C14.8371 14.8311 18.3571 12.0968 18.3571 8.72605C18.3571 5.35534 14.8371 2.62891 10.5 2.62891Z" fill="#181600">
            </path>
          </svg>
          <div className="pl-0.5 text-sm font-semibold text-default-700">
            카카오로 로그인
          </div>
        </div>
        */}
        <Button
          leftSection={<LogInIcon className="w-[18px] h-[18px] text-gray-600 stroke-2" />}
          classNames={themeVariables.button.gray}
          onClick={() => setShowIdLogin(true)}
        >
          아이디로 로그인
        </Button>
      </div>
    )
  }

  const IdLogin = () => (
    <div className="flex flex-col gap-1.5 w-[300px] mt-10">
      <Input
        ref={idRef}
        leftSectionWidth={80}
        leftSection={<div className="text-gray-500 text-[13px] font-semibold w-full pl-4">아이디</div>}
        classNames={{
          input: `${themeVariables.input.filled.input} !h-11`
        }}
      />
      <PasswordInput
        ref={passwordRef}
        leftSectionWidth={80}
        leftSection={<div className="text-gray-500 text-[13px] font-semibold w-full pl-4">비밀번호</div>}
        classNames={{
          input: `${themeVariables.input.filled.input} !h-11`
        }}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            handleLogin();
          }
        }}
      />
      <Button
        className="mt-2"
        classNames={themeVariables.button.dark}
        onClick={handleLogin}
      >
        로그인
      </Button>
    </div>
  )

  return (
    <>
      <CenterLayout>
        <div className="flex flex-col w-full m-auto items-center gap-0 pt-32">
          <Image width={80} height={80} src={images.logo} className="mb-8" alt='company-logo'/>
          <div className="text-[28px] font-bold tracking-tight">관리자 계정으로</div>
          <div className="text-[28px] font-bold tracking-tight">로그인해주세요</div>
          {showIdLogin ? <IdLogin /> : <LoginTypeSelectButton />}
        </div>
      </CenterLayout>
    </>
  )
}